module.exports = __webpack_public_path__ + "img/bg_01.546cb004.png";